<template>
	<v-modal>
		<template v-slot:header>
			<h1>Notes</h1>
		</template>
		<v-tabs ref="tabs" :tabless="true">
			<v-tab id="notes" label="Notes">
				<table>
					<thead>
						<tr>
							<th align="left">Note</th>
							<th align="left">Author</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(note, noteIndex) in notes" :key="noteIndex">
							<td align="left" v-html="note.content"/>
							<td align="left" v-html="$present('fullName', note.user.profile)"/>
						</tr>
					</tbody>
				</table>
			</v-tab>
			<v-tab id="create-note" label="Create Note">
				<form @submit.prevent="create()">
					<fieldset>
						<div>
							<div class="sr-only">
								<legend><span>New Note</span></legend>
							</div>
							<div>
								<label><span class="sr-only">Note </span>
									<div v-if="form.errors.get('content')" class="error-block">
										<p v-html="form.errors.get('content')"></p>
									</div>
									<textarea v-model="form.data.content"></textarea>
								</label>
							</div>
						</div>
					</fieldset>
				</form>
			</v-tab>
		</v-tabs>
		<template v-slot:footer>
			<ul class="actions">
				<template v-if="!creating">
					<li>
						<button
							class="button button--primary" @click.prevent="refs.tabs.goToTab('create-note')">New Note
						</button>
					</li>
				</template>
				<template v-else>
					<li>
						<button
							class="button button--secondary" @click.prevent="refs.tabs.goToTab('notes')">Cancel
						</button>
					</li>
					<li>
						<process-button
							:processing="form.processing" class="button button--primary" text="Create Note"
							@click.prevent="create()"/>
					</li>
				</template>
			</ul>
		</template>
	</v-modal>
</template>
<script>
export default {
	data() {
		return {
			form: this.newForm({
				content: null,
			}),
		};
	},

	computed: {
		creating() {
			return this.refs.tabs?.isTabSelected("create-note");
		},
	},

	props: {
		notes: {
			required: true,
			type: Array,
		},
		newTab: {
			required: true,
			type: Boolean,
		},
		url: {
			required: true,
			type: String,
		},
		then: {
			required: true,
			type: Function,
		},
	},

	methods: {
		create() {
			this.form.post(this.url).then(response => {
				this.then(response);
			});
		},
	},

	mounted() {
		if (this.newTab) {
			this.refs.tabs.goToTab("create-to-do");
		}
	},
};
</script>
